import React, { Component } from "react";
import Menu from "./Menu";
import './Projects.css'

class Projects extends Component {
	render() {
		return (
			<div>
				<Menu selected='projects' />
				<div className='row maincontent shadow'>
					<div className='col'>
						<h1>Projects</h1>
						<div className='thumbwall'>
							<img
								src='https://picsum.photos/300/200'
								class='thumb'
								alt='...'
							></img>
							<img
								src='https://picsum.photos/300/200'
								class='thumb'
								alt='...'
							></img>
							<img
								src='https://picsum.photos/300/200'
								class='thumb'
								alt='...'
							></img>
							<img
								src='https://picsum.photos/300/200'
								class='thumb'
								alt='...'
							></img>
							<img
								src='https://picsum.photos/300/200'
								class='thumb'
								alt='...'
							></img>
							<img
								src='https://picsum.photos/300/200'
								class='thumb'
								alt='...'
							></img>
							<img
								src='https://picsum.photos/300/200'
								class='thumb'
								alt='...'
							></img>
							<img
								src='https://picsum.photos/300/200'
								class='thumb'
								alt='...'
							></img>
							<img
								src='https://picsum.photos/300/200'
								class='thumb'
								alt='...'
							></img>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default Projects;
